import React, { useState, useEffect } from "react";
import { Paper, Box, Divider } from "@mui/material";
import { useSelector } from 'react-redux'
import { Select, Button, Grid, TextField, Dialog, DialogTitle, DialogContent, DialogContentText, IconButton, DialogActions, ToggleButton, ToggleButtonGroup, useMediaQuery  } from "@mui/material"; // Example using Material UI
import Autocomplete from "@mui/material/Autocomplete";
import { fetchGraphDataByCategory, fetchGraphDataByAge, fetchGraphDataUmap, fetchGraphTrend } from "../api/fetchGraphData";
import { Icon as IconifyIcon, InlineIcon as IconifyIconInline } from "@iconify/react"
import API from '../api/fetchAPI'
import VariantView from "../components/VariantView";
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import { useTheme } from '@mui/material/styles';
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel'
import FormControl from '@mui/material/FormControl'
import { useNavigate } from "react-router-dom"
import lodash from 'lodash'
import VariantGenesRenderer from '../components/VariantGenesRenderer'
import {
  Franklin as FranklinLink,
  Gnomad as GnomadLink,
  Varsome as VarsomeLink,
  ClinVar as ClinVarLink
} from '../components/linkout/Linkout'
import LargeSpinnerOverlay from '../components/util/LargeSpinnerOverlay'
import Plot from 'react-plotly.js';
import { GlobalStyles } from '@mui/material';

import ReactFlatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import { useWindowSize } from '@uidotdev/usehooks'; // or any other window size hook
import UmapDialog from '../components/UmapDialog';
import { fetchUmapCaseData }  from '../api/fetchUmapCases';

const valueToCSS = value => {
    if(lodash.isString(value)) {
        return value.replace(/[^A-Za-z0-9]/g, '');
    } else if(value != null) {
        return value
    } else {
        return 'null'
    }
}

const GraphPage = () => {
  const [graphData, setGraphData] = useState(null);
  const [labs, setLabs] = React.useState('')
  const [lab, setLab] = React.useState('')
  const [year, setYear] = React.useState('')
  const [years, setYears] = useState([]);
  const [trendResolution, setTrendResolution] = useState('quarter'); // "quarter" or "month"
  const [graph, setGraph] = React.useState('')
  const [startDate, setStartDate] = React.useState('')
  const [endDate, setEndDate] = React.useState('')
  const [casesData, setCasesData] = React.useState()
  var [isLoading, setIsLoading] = React.useState(false); // Track loading state
  var [errorMessage, setErrorMessage] = React.useState(null);
  var [statusMessage, setStatusMessage] = React.useState(null);
  const user = useSelector((state) => state.user)
  const [selectedCaseId, setSelectedCaseId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate()
  var variantId = React.useState('')
  const [variantData, setVariantData] = React.useState('')
  const [clickedCaseData, setClickedCaseData] = React.useState()
  const [rowViewMode, setRowViewMode] = React.useState(null)
  const [showPercent, setShowPercent] = useState(true);
  const [availableYears, setAvailableYears] = useState([]);

  useEffect(() => {
      if (!graphData || isLoading) {
          setIsLoading(false);
          setStatusMessage(""); // clear message AFTER UMAP is likely rendered
      }
  }, [graphData]); 
    
  useEffect(() => {
    const fetchData = async () => {
      if (graph !== 'diagUmap') return;
      console.log('useEffect...............');
      const umapCasesData = await fetchUmapCaseData(lab, null, startDate, endDate);
      console.log(umapCasesData);
      if (!umapCasesData) {
        setGraphData(null);
        setIsLoading(false);  // Fix the spinner
        setStatusMessage("Für die gewählten Optionen sind keine Falldaten verfügbar.");
        return;
      }
      setCasesData(umapCasesData);
    };
  
    if (graph !== 'diagUmap') return;
    fetchData(); // Call the async function
  
  }, [lab, startDate, endDate, graph]);
  
  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const startYear = 2016;
    const yearRange = Array.from({ length: currentYear - startYear + 1 }, (_, i) =>
      (startYear + i).toString()
    );
    setAvailableYears(yearRange.reverse()); // Latest year on top
  }, []);

  useEffect(() => {
    if (!graphData || !graphData.data) return;

    graphData.layout = {
      ...graphData.layout,
      yaxis: {
        ...graphData.layout?.yaxis,
        title: {
          text: showPercent ? "Diagnostic Yield (%)" : "Number of Cases"
        }
      }
    };
    
  
    const updatedData = graphData.data.map(trace => ({
      ...trace,
      y: showPercent ? trace.yPercent : trace.yOriginal,
    }));
    setGraphData({ ...graphData, data: updatedData });
    
  
  }, [showPercent]);
  
  const RowViewComponent = VariantView

  React.useEffect(() => {
      loadVariantData()
  }, [variantId])

  const [rowViewControl, setRowViewControl] = React.useState({
      isOpen: false,
      row: null
  })

  const openRowDetailView = (row) => {
      setRowViewControl({
          isOpen: true,
          row: row
      })
  }

  const closeRowDetailView = () => {
      setRowViewControl({
          isOpen: false,
          row: null
      })
  }

  const renderRowView = () => {


    if(rowViewControl?.row != null && RowViewComponent != null ) {

        return(
          <div>
            <Dialog 
              open={isModalOpen} 
              onClose={() => setIsModalOpen(false)}             
              scroll='body'
              fullWidth={false} // Disable fullWidth to allow dynamic width
              maxWidth={false} // Disable maxWidth to allow content to determine width
            >
            <DialogTitle>Case Details</DialogTitle>
              <DialogContent>
                <RowViewComponent fromVisualisation={true} bla={'123'} row={rowViewControl.row} />
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setIsModalOpen(false)} color="primary">
                  Close
                </Button>
            </DialogActions>
            </Dialog>
          </div>
        )

    }

    console.log('nein')

    return null
  }

  const handleYearsChange = (event) => setYears(event.target.value);
  const handleTrendResolutionChange = (event, newResolution) => {
    if (newResolution) {
      setTrendResolution(newResolution);
    }
  };
  
  const quarter_of_the_year = (date) => {
    // Get the month component of the provided date and add 1 (as months are zero-based) and store it in the variable month
    var month = date.getMonth() + 1;
    // Calculate the quarter of the year by dividing the month by 3 and rounding up to the nearest integer
    return (Math.ceil(month / 3));
  }

  const handleFetchGraph = async () => {

    setGraphData(null);

    if(lab)  {
      // Set busy cursor
      setIsLoading(true);  // Start loading
      isLoading = true
      console.log("Fetching Cases Data...");
      console.log(isLoading);
      try {
        //await loadCasesAndFetchGraph(); // Ensure loadCasesAndFetchGraph completes before proceeding
      } finally {
      }
    } else {
        setErrorMessage('Labor ist erforderlich')
    }
  };

  // Fetch graph data when casesData is updated
  useEffect(() => {

    setGraphData(null);


    if (casesData) {
      console.log("Fetching Cases Data...");
        console.log(Object.keys(casesData).length);
          
        if (Object.keys(casesData).length != 0) {
           // Set busy cursor
           setIsLoading(true); // Start loading

        if (graph === 'diagUmap') {
          setStatusMessage("UMAP wird erstellt… dies kann einige Sekunden dauern ⏳");
        } else {
          setStatusMessage(""); // Clear it for other graphs
        }
          try {
            let fetchResponse;
            switch(graph) {

              case 'diagYieldByCategory': 
                fetchResponse = fetchGraphDataByCategory(casesData)
                break;
              case 'diagYieldByAge': 
                fetchResponse = fetchGraphDataByAge(casesData)
                break;
              case 'diagUmap': 
                fetchResponse = fetchGraphDataUmap(casesData)
                break;
              case 'trend': 
                fetchResponse = fetchGraphTrend(casesData, trendResolution);
                break;
              default:
                break;
            }
            fetchResponse.then(response => {
              console.log(response);

              // The visualiser replies { status: 'computing' | 'not_ready', ... }
              // (relayed as 200 by the HGQN proxy) when the UMAP layout cache
              // isn't available. That's not a plot -- show the message and stop,
              // so the spinner doesn't hang forever.
              if (graph === 'diagUmap' && response && typeof response === 'object'
                  && (response.status === 'computing' || response.status === 'not_ready'
                      || response.status === 'case_not_in_layout')) {
                setGraphData(null);
                setIsLoading(false);
                setStatusMessage(
                  response.message ||
                  "Das UMAP-Layout wird im Hintergrund neu berechnet. Das kann lange dauern – bitte später erneut versuchen."
                );
                return;
              }

              var parsed;
              if (graph == 'trend')
                parsed = response;
              else {
                parsed = JSON.parse(response);
                console.log("Raw plot data before normalization:", parsed.data);
              }

              if (graph != 'diagUmap') {
                
                parsed.layout = {
                  ...parsed.layout,
                  yaxis: {
                    ...parsed.layout?.yaxis,
                    title: {
                      text: showPercent ? "Diagnostic Yield (%)" : "Number of Cases"
                    }
                  }
                };
                
                // Normalize y values to percentages
                parsed.data = parsed.data.map(trace => {
                  const yOriginal = [...trace.y]; // absolute count
                  const yPercent = trace.customdata?.map(d => parseFloat(d[0]) * 100); // extract %
                  return {
                    ...trace,
                    y: showPercent ? yPercent : yOriginal,
                    yOriginal,
                    yPercent,
                    hovertemplate: "%{x}<br>%{y}"
                  };
                });
              }
              setGraphData(parsed);
              setIsLoading(false);
              setStatusMessage("");   // clear "Generating UMAP…" once the plot is in
            }).catch(error => {
              console.error("Error fetching graph data:", error);
              setGraphData(null);
              setIsLoading(false);
              setStatusMessage("Das Diagramm konnte nicht geladen werden. Bitte erneut versuchen.");
            });
          } finally {
              // Reset cursor to default after fetching is done
              //setIsLoading(false); // Stop loading
          }
        } else  {
            setGraphData(null);
            setIsLoading(false);  // Fix the spinner
            setStatusMessage("Für die gewählten Optionen sind keine Falldaten verfügbar.");
        }
    } 
  }, [casesData, trendResolution]); // Runs when casesData, trendResolution updates

  const handleYearChange = (event) => {
        setYear(event.target.value)
    }


  const handleLabChange = (event) => {
        setLab(event.target.value)
    }
  
  const handleGraphChange = (event) => {
        setGraph(event.target.value)
    }

  const loadLabData = () => {
    var path;
    if (user && user.isSuperuser === true) {
      path = "/api/labs/list/"
    } else if (user) {
      path = `/api/labs/get/${user.lab}`
    }
    API.get(path).then((response) => {
      const sortedLabs = response.data.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
      setLabs(sortedLabs);
    });
  }

  useEffect(() => {
    setGraphData(null);
    if (!lab) {
      setErrorMessage("❗Bitte wählen Sie ein Labor aus.");
      return;
    }
    if (!graph) {
      setErrorMessage("❗Bitte wählen Sie einen Diagrammtyp aus.");
      return;
    }
    if (graph === "trend" && years.length==0) {
      setErrorMessage("❗Bitte wählen Sie mindestens ein Jahr für das Trenddiagramm aus.");
      return;
    }
    
    // Clear previous error if all OK
    setErrorMessage(null);    
  
    setIsLoading(true)

    if (graph === 'diagUmap') return; // UMAP is handled in a separate useEffect above
      API.get(`/api/labs/get/cases/${lab}`, { doNotThrowFor: [404] }).then(response => {
        console.log(response.cases)
        // Filter cases based on the selected start and end dates
        const filteredCases = response.cases.filter((caseItem) => {

          if (graph === 'trend') 
            return true;
          const caseTimestamp = Date.parse(caseItem.befunddatum); // Use Date.parse for more reliable parsing

          //  Check if the 'befunddatum' is a valid Date
          if (isNaN(caseTimestamp)) {
            console.error(`Invalid date for case ID: ${caseItem.internalCaseId}, befunddatum: ${caseItem.befunddatum}`);
            return false; // Skip invalid dates
          }

          const caseDate = new Date(caseTimestamp); // Assuming `date` is in ISO string or Date format

          // If both startDate and endDate are selected, filter based on the range
          if (startDate && endDate) {
              return caseDate >= startDate && caseDate <= endDate;
          }

          // If only one date is provided (startDate or endDate), use that to filter
          if (startDate) {
              return caseDate >= startDate;
          }

          if (endDate) {
              return caseDate <= endDate;
          }

          // If no date filters, return all cases
          return true;
        });
    
    let transformedData;

    if (graph) {
      switch(graph) {

      case 'diagYieldByCategory': 
        transformedData = filteredCases.map((caseItem) => ({
          id: caseItem.internalCaseId,  // Convert internalCaseId to integer
          solved: caseItem.caseStatus ? caseItem.caseStatus : 'unclear', // Map caseStatus to is_solved
          disease_category: caseItem.diseaseCategory ? caseItem.diseaseCategory : 'unspecified'
        }));
        break;
      case 'diagYieldByAge': 
        console.log(filteredCases)
        transformedData = filteredCases.map((caseItem) => ({
          id: caseItem.internalCaseId,  // Convert internalCaseId to integer
          solved: caseItem.caseStatus ? caseItem.caseStatus : 'unclear', // Map caseStatus to is_solved
          age_group: parseInt(caseItem.ageinYears) >= 18 ? 'adult' : 'child' ,  // Map age
        }));
        break;
      case 'diagUmap': 
        break;
      case 'trend': 
        if (years && years.length > 0) {
          const yearCases = filteredCases.filter((caseItem) => {
            const caseTimestamp = Date.parse(caseItem.befunddatum);
            if (isNaN(caseTimestamp)) return false;
            const caseYear = new Date(caseTimestamp).getFullYear().toString();
            return years.includes(caseYear);  // <-- key change: match any selected year
          });
      
          transformedData = yearCases.map((caseItem) => {
            const caseDate = new Date(Date.parse(caseItem.befunddatum));
            return {
              id: caseItem.internalCaseId,
              solved: caseItem.caseStatus ? caseItem.caseStatus : 'unclear',
              year: caseDate.getFullYear(),           
              quarter: quarter_of_the_year(caseDate), // 1..4
              month: caseDate.getMonth() + 1          // 1..12
            };
          });
        } else {
          setGraphData(null);
        }
        break;
      default:
        break;
    }
  }

    console.log(transformedData)
    setCasesData(transformedData)

  }).catch(e => {
  console.error(`Could not load lab data for id '${lab._id}'`)
  console.error(e)
  setIsLoading(false)
 })}, [years, lab, graph, startDate, endDate]) // Run when lab, years,  graph, startDate, endDate changes;

useEffect(() => {
    loadLabData()
}, []); 

function ClassificationSummary({variantId, cases: _cases}) {

    // TODO: Pro Category gibt es columns, die nur per expand angezeigt werden können
    // Dazu einen kleinen button oben rechts in der Category
    // Bei Klick wird ein flag für die Category auf true gesetzt und alle hidden columns werden gerendert
    // So können die zusätzlichen Infos pro Category angezeigt werden

    const tableConfig = [
        {
            id: 'case',
            label: 'Case Identifikation',
            cols: [
                {
                    id: 'sequencingLab',
                    label: 'Sequencing Lab',
                    path: 'sequencingLab.shortName'
                }, {
                    id: 'internalCaseId',
                    label: 'Internal Case ID',
                    path: 'internalCaseId'
                }
            ],
        }, {
            id: 'diagnosis',
            label: 'Diagnose',
            cols: [{
                id: 'hpoTerms',
                label: 'HPO Term',
                path: 'hpoTermsWithLabel'
            }],
            
        }, {
            id: 'clinicalInterpretation',
            label: 'Klinische Interpretation',
            cols: [{
                id: 'acmgClass',
                label: 'ACMG Class',
                path: 'variant.acmg.class'
            }, {
                id: 'acmgCriteria',
                label: 'ACMG Criteria',
                path: 'variant.acmg.criteria'
            }],
        }
    ]

    const cases = React.useMemo( () => lodash.isArray(_cases) ? _cases.map( item => {
        if(lodash.isArray(item.variants)) {
            for(let variant of item.variants) {
                if(variant?.variant?.reference === variantId) {
                    item.variant = variant
                    break
                }
            }
        }
        return item
    }) : null, [_cases])






    /*
    const cellRefs = React.useRef([])

    React.useEffect(() => {
        if(tableConfig != null && lodash.isNumber(tableConfig.length) && tableConfig.length > 0 && cases != null && lodash.isNumber(cases.length) && cases.length >0) {
            cellRefs.current = cases.map((caseItem,i) => {
                let rowRefs = {}
                tableConfig.map(config => config.cols.map(col => rowRefs[config.id + '_' + col.id] = null))
                return rowRefs
            })
            console.log(cellRefs)
        }
    }, [tableConfig, cases])
    */


    const cellRefs = React.useRef(new Map())
    const [rowHeight, setRowHeight] = React.useState(new Map())

    React.useEffect(() => {
        let nextRowHeight = new Map()
        for(let [key,cell] of cellRefs.current.entries()) {
            let rowIndex = parseInt(key.substring(0,key.indexOf('_')))

            // console.log(key + ' ' + cell)
            // console.log(rowIndex)
            // console.log(cell.clientHeight)
            // console.log(cell.querySelector('.value'))
            // console.log(cell.querySelector('.value').clientHeight)
            // console.log(" ")

            let valueHeight = cell != null && cell.querySelector('.value') != null ? cell.querySelector('.value').clientHeight : 0

            if(lodash.isNumber(nextRowHeight.get(rowIndex)) == false || valueHeight > nextRowHeight.get(rowIndex)) {
                nextRowHeight.set(rowIndex, valueHeight)
            }
        }

        setRowHeight(nextRowHeight)

        console.log("JAJAJAJAJAAJJAAJAJAJAJAJAJAJA")
        console.log(nextRowHeight)
        
    }, [cellRefs])



    React.useEffect(() => {
        console.log('useEffect: rowheight')
        console.log(rowHeight)
    }, [rowHeight])





    // React.useEffect(() => {

    //     if(tableConfig != null && lodash.isNumber(tableConfig.length) && tableConfig.length >0 && cases != null && lodash.isNumber(cases.length) && cases.length >0) {
    //         console.log("LKFKJEWLHFKJEWHF")
    //         console.log(tableConfig.length)
    //         console.log(cases.length)
    //         let refs = []
    //         for(let i=0; i<cases.length; i++) {
    //             let row = []
    //             for(let j=0; j<tableConfig.length; j++) {
    //                 row.push(React.useRef())
    //             }
    //             refs.push(row)
    //         }
    //     }

    // }, [tableConfig, cases])

    // React.useEffect(() => {
    //     console.log("tableRef changed")
    //     console.log(tableRef)
    // }, {tableRef})



    const renderValue = (item,col) => {

        let value = lodash.get(item,col.path)
        let ret = <div className='value'></div>

        // console.log(JSON.stringify(value))

        if(lodash.isArray(value)) {
            ret = <div className='value'>{value.map(item => <div className={`item VALUE-${valueToCSS(item)}`}>{item}</div>)}</div>
        } else if(lodash.isObject(value)) {
            ret = <div className='value'>{JSON.stringify(value)}</div>
        } else {
            ret = <div className={`value VALUE-${valueToCSS(value)}`}>{value}</div>
        }

        return ret
    }

    return (

        <div
            // ref={el => {console.log('ABC'); console.log(el);}}
            className="classification-table box"
        >
            { lodash.isArray(cases) && cases.length > 0 ?
                lodash.isArray(tableConfig) ? tableConfig.map( category =>
                    <div className={`category ${category.id}`}>
                        <div className="label">{category.label}</div>
                        <div className="columns">
                            { lodash.isArray(category.cols) ? category.cols.map( col =>
                                <div className={`column ${col.id}`}>
                                    <div className={`header ${col.id}`}>{col.label}</div>
                                    { cases.map( (item,caseIndex) =>
                                        <div
                                            style={{
                                                height: rowHeight.get(caseIndex) == null ? 0 : rowHeight.get(caseIndex)
                                            }}
                                            ref={element => cellRefs.current.set(caseIndex + '_' + category.id + '_' + col.id, element)}
                                            className={`cell ${col.id} ${caseIndex}`}
                                        >
                                            { renderValue(item,col) }
                                        </div>
                                    )}
                                </div>
                            ) : null }
                        </div>
                    </div>
                ) : null
            :
                <div className="empty">
                    no cases found
                </div>
            }

            


            






        </div>
    )

}

function loadVariantData() {

        // console.log("LOAD VARIANT DATA")
        // console.log(props)
        // console.log(variantId)

        if (variantId == null || lodash.isString(variantId) === false || variantId.length <= 0) {
            return
        }

        setIsLoading(true)

        // console.log("CALL")

        API.get(`/api/variants/get/${variantId}`, { doNotThrowFor: [404] }).then(response => {
            setVariantData(response.variant)
            setClickedCaseData(response.cases)
            setIsLoading(false)
            console.log(response.variant)

        }).catch(e => {
            console.error(`Could not load variant data for id '${variantId}'`)
            console.error(e)
            navigate('/notfound')
        })
    }

    const [fullscreen, setFullscreen] = useState(false);
    const [windowSize, setWindowSize] = useState({ width: window.innerWidth, height: window.innerHeight });
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
    
    useEffect(() => {
      const handleResize = () => {
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      };
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);  

    const toggleFullscreen = () => {
      setFullscreen(!fullscreen);
    };

    const getPlotDimensions = () => {
      if (fullscreen) {
        return {
          width: windowSize.width * 0.96, // Use 96% of the window width to leave some padding
          height: windowSize.height * 0.99, // Use 90% of the window height for fullscreen
        };
      } else {
        return {
          width: isSmallScreen ? windowSize.width * 0.95 : windowSize.width * 0.46, // Adjust width for small screens
          height: windowSize.height * 0.65, // Default height for non-fullscreen mode
        };
      }
    };

    const { width, height } = getPlotDimensions();
        // Make the outer container taller than the actual plot so ticks/labels never get masked
    const outerPlotPadding = 10; // extra room below the "paper" 

    const plotComponent = (
      
      <Plot
      data={graphData?.data}
      layout={{
        ...graphData?.layout,
        width,
        height: height - 80,                                  
        margin: { t: 30, b: outerPlotPadding, l: 16, r: 10 }, 
      }}
     
      style={{ width: '100%', overflow: 'visible' }}
      config={{ responsive: false }}
      onClick={(event) => {
        if (graph !== 'diagUmap') 
          return;
        if (event.points && event.points.length > 0) {
          const clickedPoint = event.points[0];
          const comment = clickedPoint.customdata || clickedPoint.text || clickedPoint.hovertext || clickedPoint.pointIndex;
          const idText = comment.split('ID: ')[1];
          if (!idText) 
            return;
          var caseId = casesData.cases.filter(
            function(data){ return data.case_ID_paper == idText.split('<br>')[0] })

          variantId = caseId[0].variantId 
          console.log(variantId)

          var row = {}
          row.id = variantId

          setIsModalOpen(true);
          openRowDetailView(row)

          // loadVariantData() 
          // setSelectedCaseId(caseId);
        }
      }}
      />
    );

    const plotWithOverlay = (
      <div style={{ position: 'relative', overflow: 'visible' }}>
        {plotComponent}
        <IconButton title="Toggle between % and absolute values"
          style={{
            position: 'absolute',
            top: 5,
            left: 5,
            zIndex: 10,
            backgroundColor: '#f5f5f5',
            border: '2px solid #1976d2',
            borderRadius: '8px',
            padding: '6px 8px',
            cursor: 'pointer',
            fontWeight: 'bold',
            fontSize: '20px',
            color: '#1976d2',
            boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
            '&:hover': {
              backgroundColor: '#e3f2fd',
            },
          }}
          onClick={(e) => {
            e.stopPropagation();
            setShowPercent(prev => !prev);
  
            // Re-map y values based on toggle
            if (graphData?.data) {
  
              const updatedData = graphData.data.map(trace => ({
                ...trace,
                y: showPercent ? trace.yPercent : trace.yOriginal,
              }));
              setGraphData({ ...graphData, data: updatedData });
  
            }
          }}
        >
        <span style={{ fontSize: 14, fontWeight: 'bold' }}>
          {showPercent ? '#' : '%'}
        </span>
        </IconButton>
      </div>
    );

    return (

      
      <div
        style={{
          padding: 20,
          paddingBottom: 64,     // leave room for fixed footer
          cursor: isLoading ? "wait" : "default",
          minHeight: '100vh',
          overflowY: 'auto',     // <-- ensure page can scroll past the chart
        }}
      >
      <GlobalStyles styles={{
        '.js-plotly-plot, .plot-container, .svg-container': { overflow: 'visible !important' },
        '.MuiPaper-root': { overflow: 'visible !important' },   // belt & braces
      }}/>
      
      <h2>Auswählen von Daten für das Diagramm</h2>
    
      {/* Controls wrapped in a Paper */}
      <Paper elevation={8} style={{ padding: 10, marginBottom: 10 }}>
      <Grid container spacing={3}>
      {/* Combo Boxes for Labor and Diagrammtyp */}
      <Grid item xs={12} sm={6}>
        <Autocomplete
        options={labs}
        getOptionLabel={(option) => option.name}
        value={
        Array.isArray(labs)
        ? labs.find((l) => l._id === lab) || null
        : null
        }
        onChange={(e, v) => setLab(v ? v._id : "")}
        renderInput={(params) => (
        <TextField {...params} label="Labor" variant="filled" size="small" fullWidth />
        )}
        isOptionEqualToValue={(o, v) => o._id === v._id}
        />
      </Grid>
      
      <Grid item xs={12} sm={6}>
        <FormControl variant="filled" fullWidth size="small">
        <InputLabel id="graph-label">Diagrammtyp</InputLabel>
        <Select labelId="graph-label" value={graph} onChange={(e) => setGraph(e.target.value)}>
        <MenuItem value="diagYieldByCategory">Diagnostische Ausbeute nach Krankheitskategorie</MenuItem>
        <MenuItem value="diagYieldByAge">Diagnostische Ausbeute nach Altersgruppe</MenuItem>
        <MenuItem value="trend">Trend der diagnostischen Ausbeute</MenuItem>
        <MenuItem value="diagUmap">UMAP-Clustering</MenuItem>
        </Select>
        </FormControl>
      </Grid>
      
      {/* Trend Controls */}
      {graph === 'trend' ? (
        <>
        {/* Befunddatum Jahre in the first column */}
        <Grid item xs={12} sm={6}>
        <FormControl variant="filled" fullWidth size="small">
        <InputLabel id="years-label">Befunddatum Jahre</InputLabel>
        <Select
          labelId="years-label"
          multiple
          value={years}
          onChange={(e) => setYears(e.target.value)}
          style={{ height: '40px' }} // Ensure consistent height
        >
           {availableYears.map((year) => (
            <MenuItem key={year} value={year}>
              {year}
            </MenuItem>
          ))}
        </Select>
        </FormControl>
        </Grid>
      
        {/* Quartalsweise/Monatlich Buttons in the second column */}
        <Grid item xs={12} sm={6}>
        <ToggleButtonGroup
        value={trendResolution}
        exclusive
        onChange={(e, v) => v && setTrendResolution(v)}
        aria-label="Trendauflösung"
        size="small"
        fullWidth
        style={{ height: '40px' }} // Ensure consistent height
        >
        <ToggleButton value="quarter">Quartalsweise</ToggleButton>
        <ToggleButton value="month">Monatlich</ToggleButton>
        </ToggleButtonGroup>
        </Grid>
        </>
      ) : (
        <>
        {/* Start Date */}
        <Grid item xs={12} sm={6}>
        <Box>
        <label style={{ fontSize: '0.85rem', display: 'block', marginBottom: 4 }}>
          Start BefundDatum:
        </label>
        <ReactFlatpickr
          value={startDate}
          onChange={(dates) => setStartDate(dates[0])}
          options={{ allowInput: true }}
          placeholder="Start BefundDatum"
          style={{ height: '40px' }} // Ensure consistent height
        />
        </Box>
        </Grid>
      
        {/* End Date */}
        <Grid item xs={12} sm={6}>
        <Box>
        <label style={{ fontSize: '0.85rem', display: 'block', marginBottom: 4 }}>
          End BefundDatum:
        </label>
        <ReactFlatpickr
          value={endDate}
          onChange={(dates) => setEndDate(dates[0])}
          options={{ allowInput: true }}
          placeholder="End BefundDatum"
          style={{ height: '40px' }} // Ensure consistent height
        />
        </Box>
        </Grid>
        </>
      )}
      
      {/* Button - placed inside the Paper 
        <Grid item xs={12} style={{ textAlign: "center", marginTop: 10 }}>
        <Button
        variant="contained"
        color="primary"
        onClick={handleFetchGraph}
        size="medium"
        disabled={isLoading}
        >
        {isLoading ? "Lade..." : "Diagramm anzeigen"}
        </Button>
      </Grid>*/}
      </Grid> 
      </Paper>
      
      {/* Diagram and Description */}
      <Paper elevation={8} style={{ padding: 10, marginTop: 1 , boxSizing: 'border-box', overflow: 'visible' }}>
        <Grid container columnSpacing={1} rowSpacing={1} >
        {/* Diagram Section */}
        <Grid item xs={12} sm={6} >
          <div className="description">
          <h3>Diagramm</h3>
          {statusMessage && (
            <div style={{
                fontSize: "1rem",
                marginBottom: "10px",
                color: "#555",
                fontStyle: "italic"
              }}>
                {statusMessage}
            </div>
          )}

          <div style={{ overflow: 'visible', position: 'relative' }}>
            {graphData ? (
            <div style={{ padding: 0, maxWidth: '100%', boxSizing: 'border-box' }}>
              <div style={{ position: 'relative' }}>

              {graph !== 'diagUmap' ? plotWithOverlay : plotComponent}
      
              <IconButton title="Full screen mode"
                style={{
                  position: 'absolute',
                  top: 20,
                  right: 8,
                  zIndex: 10,
                  backgroundColor: '#f5f5f5',
                  border: '2px solid #1976d2',
                  borderRadius: '8px',
                  padding: '2px 4px',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  fontSize: '4px',
                  color: '#1976d2',
                  boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
                    '&:hover': {
                    backgroundColor: '#e3f2fd',
                  },
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  toggleFullscreen();
                }}
              >
              <FullscreenIcon />
              </IconButton>
              </div>
              {/* <Dialog open={fullscreen} onClose={toggleFullscreen} maxWidth={false} fullWidth>
                <DialogContent style={{ padding: 0, backgroundColor: 'white', overflow: 'auto'}}>
                  {graph !== 'diagUmap' ? plotWithOverlay : plotComponent}
                </DialogContent>
              </Dialog> */}
              <UmapDialog
                open={fullscreen}
                onClose={toggleFullscreen}
                graphData={graphData}
                plotComponent={graph !== 'diagUmap' ? plotWithOverlay : plotComponent}
                onClickPoint={(event) => {
                  if (event.points && event.points.length > 0) {
                    const clickedPoint = event.points[0];
                    const comment = clickedPoint.customdata || clickedPoint.text || clickedPoint.hovertext || clickedPoint.pointIndex;
                    const idText = comment.split('ID: ')[1];
                    if (!idText) return;
                    const caseId = casesData.cases.find(data => data.case_ID_paper === idText.split('<br>')[0]);
                    variantId = caseId.variantId;
                    setIsModalOpen(true);
                    openRowDetailView({ id: variantId });
                  }
                }}
                isFullscreen={fullscreen}
                toggleFullscreen={toggleFullscreen}
                windowSize={windowSize}
              />
            </div>
            ) : (
            <div>
            <p>Keine Diagrammdaten verfügbar</p>
              <p style={{ color: "red", marginTop: "1rem" }}>
                {errorMessage}
              </p>
            </div>
            )}   
            { renderRowView() }
          </div>
        </div>
        </Grid>
      
        {/* Description Section */}
        <Grid item xs={12} sm={6} >
          <div className="description" style={{ display: 'flex', flexDirection: 'column' }}>
          <h3>Diagramm Beschreibung</h3>
          <div style={{ flex: 1, overflowY: 'auto' }}>
            {graph === 'diagYieldByCategory' && (
            <p>
              <strong>Diagramm zur diagnostischen Ausbeute nach Krankheitskategorie</strong>
              <br />
              Dieses Diagramm zeigt die diagnostische Ausbeute in Prozent für verschiedene Krankheitskategorien.
            </p>
            )}
            {graph === 'diagYieldByAge' && (
            <p>
              <strong>Diagramm zur diagnostischen Ausbeute nach Altersgruppe</strong>
              <br />
              Dieses Diagramm zeigt die diagnostische Ausbeute in Prozent für verschiedene Altersgruppen.
            </p>
            )}
            {graph === 'trend' && (
            <p>
              <strong>Diagramm zur diagnostischen Ausbeute im Zeitverlauf</strong>
              <br />
              Dieses Diagramm zeigt die diagnostische Ausbeute im Zeitverlauf, aufgeteilt nach Quartalen oder Monaten.
            </p>
            )}
            {graph === 'diagUmap' && (
            <p>
              <strong>Diagramm zur UMAP-Analyse von Patientendaten</strong>
              <br />
              Die UMAP-Einbettung von Patientenphänotypen zeigt eine krankheitsbezogene Häufung von Fällen.
            </p>
            )}
          </div>
          </div>
          <div>
            { isLoading === true ?
                    <LargeSpinnerOverlay label="loading..."/>
                  : 
                    null
            }
          </div>
        </Grid>
        </Grid>
        </Paper>
      </div>  
    ); 
};





export default GraphPage;
